import articleNumbers from './whitelist.json';

export default (articleNumber) => {
    if (window.Checkout.settings.enable_smf_click_and_collect) {
        return articleNumbers.includes(String(articleNumber));
    }
    return false;
};
